import {
    updateContactsInDatabase,
    updateSpecificContactInDatabase
} from "../../Restricted/Contacts/BrowserDatabaseFunctions";

export const E_getContactsChangesResults = (_incoming) => {
    console.log("E_getContactsChangesResults : ", _incoming);

    /*
        add/update any Contacts that have been added or updated
        but only update the fields that need updating - based on the incoming bc
        it's just a subset of all the Contact fields
     */

    try {
        // Get the array of updated/added contacts
        const masterContacts = _incoming.master_contacts;

        updateContactsInDatabase(masterContacts).then((_response) => {
            console.log(`Successfully synced ${masterContacts.length} contacts.`);



        })

    } catch (e){
        console.error("ERROR:", e);
    }
}

export const updateMasterContactsAttendeeFieldsResults = (_incoming) => {
    console.log("updateMasterContactsAttendeeFieldsResults : ", _incoming);

    /*
        add/update any Contacts that have been added or updated
        but only update the fields that need updating - based on the incoming bc
        it's just a subset of all the Contact fields
     */

    try {
        // Get the array of updated/added contacts
        const contactData = {
            id: _incoming.updated_attendee_id, // Assuming 'id' is the keyPath

            fname: _incoming.fname,
            lname: _incoming.lname,
            nickname: _incoming.nickname,

            image: _incoming.image,
            avatar: _incoming.avatar,

            address: _incoming.address,
            city: _incoming.city,
            state: _incoming.state,
            zip: _incoming.zip,
            country: _incoming.country,

            email: _incoming.email,
            dob: _incoming.dob,

            phone_prefix: _incoming.phone_prefix,
            phone: _incoming.phone,

            language: _incoming.language,
            preferred_airport: _incoming.preferred_airport,

            last_mod: _incoming.last_mod
        };

        updateSpecificContactInDatabase(contactData).then((_response) => {
            console.log("Successfully synced contact.");



        })

    } catch (e){
        console.error("ERROR:", e);
    }
}